export default __webpack_public_path__ + "static/media/topgun7.44842f57.jpeg";